




















































































import { Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import OriginatorsFilter from "@/components/Settings/Originators/OriginatorsFilter.vue";
import {OriginatorItem} from "@/store/settings/originators/types";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import PartnersFilter from "@/components/Settings/Partners/PartnersFilter.vue";

@Component({components: {PartnersFilter, OriginatorsFilter,ScrollButton}})
export default class Originators extends BaseItemsPage<OriginatorItem> {
  @Getter("originators") originatorResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'originator',
    'partner',
    'transport',
    'status',
    'description',
  ];

  getData(): any {
    return this.originatorResponse;
  }
}
